import React, { useState } from 'react';
import { commonStyles } from '../styles/commonStyles';
import { API_URL } from '../utils/constants';

function LoginPage({ onLoginSuccess }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loginError, setLoginError] = useState('');
  const [downloadPassword, setDownloadPassword] = useState('');
  const [showDownloadForm, setShowDownloadForm] = useState(false);
  const [downloadError, setDownloadError] = useState('');

  const handleLogin = async () => {
    setLoginError('');
    
    try {
      const response = await fetch(`${API_URL}/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      });

      if (response.ok) {
        const data = await response.json();
        sessionStorage.setItem('token', data.token);
        sessionStorage.setItem('userRole', data.role);
        onLoginSuccess(data.token, data.role);
      } else {
        setLoginError('아이디 또는 비밀번호가 올바르지 않습니다.');
      }
    } catch (error) {
      setLoginError('서버 연결 오류가 발생했습니다.');
    }
  };

  const handleDownload = async () => {
    setDownloadError('');
    
    try {
      const response = await fetch(`${API_URL}/download-remote-support`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password: downloadPassword })
      });

      const contentType = response.headers.get('content-type');
      
      if (!response.ok) {
        if (contentType && contentType.includes('application/json')) {
          const errorData = await response.json();
          setDownloadError(errorData.error || '다운로드 중 오류가 발생했습니다.');
        } else {
          setDownloadError('다운로드 중 오류가 발생했습니다.');
        }
        return;
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'rustdesk-host=pctools.myds.me,key=XmUq2VBxfKka6pg9IPH6LOKuSLtubiH4ZjtcLqxHEhk=,.exe';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      
      setDownloadPassword('');
      setShowDownloadForm(false);
      
    } catch (error) {
      console.error('다운로드 오류:', error);
      setDownloadError('다운로드 중 오류가 발생했습니다.');
    }
  };

  return (
    <div style={commonStyles.loginContainer}>
      {/* 우측 상단 원격지원 프로그램 버튼 */}
      <div style={{
        position: 'absolute',
        top: '40px',
        right: '40px',
        zIndex: 1000
      }}>
        {!showDownloadForm ? (
          <button
            onClick={() => setShowDownloadForm(true)}
            style={{
              padding: '18px 36px',
              fontSize: '19px',
              fontWeight: '600',
              color: 'white',
              background: 'linear-gradient(135deg, #3498db 0%, #2980b9 100%)',
              border: 'none',
              borderRadius: '0',
              cursor: 'pointer',
              boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 24px 70px rgba(0,0,0,0.4)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 20px 60px rgba(0,0,0,0.3)';
            }}
          >
            원격지원 프로그램
          </button>
        ) : (
          <div style={{
            ...commonStyles.loginCard,
            width: '340px',
            padding: '20px'
          }}>
            <h3 style={{ 
              margin: '0 0 15px 0', 
              color: '#2c3e50',
              fontSize: '20px',
              textAlign: 'center'
            }}>
              원격지원 프로그램 다운로드
            </h3>
            
            {/* 안내 문구 박스 */}
            <div style={{
              backgroundColor: '#e3f2fd',
              border: '1px solid #2196f3',
              borderRadius: '4px',
              padding: '12px',
              marginBottom: '15px',
              fontSize: '13px',
              color: '#0d47a1',
              lineHeight: '1.6'
            }}>
              상단에 <strong>다운로드 차단</strong> 팝업이 나오는 경우<br/>
              팝업을 클릭하면 <strong>계속 다운로드</strong>를 선택할 수 있습니다.<br/>
			  <strong>다운로드</strong>된 파일은 우측 상단 다운로드 화살표 아이콘을<br/> 
			  클릭 후 파일을 선택하면 실행됩니다.
            </div>

            <div style={commonStyles.inputWrapper}>
              <input
                type="password"
                placeholder="비밀번호"
                value={downloadPassword}
                onChange={(e) => setDownloadPassword(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleDownload()}
                style={commonStyles.loginInput}
              />
            </div>
            {downloadError && (
              <div style={{
                ...commonStyles.loginError,
                marginBottom: '10px'
              }}>
                {downloadError}
              </div>
            )}
            <div style={{ display: 'flex', gap: '10px' }}>
              <button
                onClick={handleDownload}
                style={{
                  ...commonStyles.loginButton,
                  flex: 1
                }}
              >
                다운로드
              </button>
              <button
                onClick={() => {
                  setShowDownloadForm(false);
                  setDownloadPassword('');
                  setDownloadError('');
                }}
                style={{
                  ...commonStyles.loginButton,
                  flex: 1,
                  backgroundColor: '#95a5a6'
                }}
              >
                취소
              </button>
            </div>
          </div>
        )}
      </div>

      {/* 기존 로그인 폼 */}
      <div style={commonStyles.loginCard}>
        <div style={commonStyles.loginHeader}>
          <h1 style={commonStyles.loginTitle}>PCTOOLS</h1>
          <p style={commonStyles.loginSubtitle}>작업 관리 시스템</p>
        </div>
        <div style={commonStyles.loginForm}>
          <div style={commonStyles.inputWrapper}>
            <input
              type="text"
              placeholder="아이디"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleLogin()}
              style={commonStyles.loginInput}
            />
          </div>
          <div style={commonStyles.inputWrapper}>
            <input
              type="password"
              placeholder="비밀번호"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleLogin()}
              style={commonStyles.loginInput}
            />
          </div>
          {loginError && <div style={commonStyles.loginError}>{loginError}</div>}
          <button onClick={handleLogin} style={commonStyles.loginButton}>
            로그인
          </button>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
